export const categories = [
  {
    id: 'shoes',
    nameKey: 'category.shoes',
    polishName: 'Buty',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    seq: 'cat-01',
    color: 'bg-rose-100/60',
  },
  {
    id: 'hoodies',
    nameKey: 'category.hoodies',
    polishName: 'Bluzy / Swetry',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    seq: 'cat-02',
    color: 'bg-emerald-100/60',
  },
  {
    id: 'tshirts',
    nameKey: 'category.tshirts',
    polishName: 'T-Shirty',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    seq: 'cat-03',
    color: 'bg-amber-100/60',
  },
  {
    id: 'jackets',
    nameKey: 'category.jackets',
    polishName: 'Kurtki',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    seq: 'cat-04',
    color: 'bg-sky-100/60',
  },
  {
    id: 'pants',
    nameKey: 'category.pants',
    polishName: 'Spodnie / Szorty',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    seq: 'cat-05',
    color: 'bg-violet-100/60',
  },
  {
    id: 'headwear',
    nameKey: 'category.headwear',
    polishName: 'Nakrycia głowy',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    seq: 'cat-06',
    color: 'bg-teal-100/60',
  },
  {
    id: 'sets',
    nameKey: 'category.sets',
    polishName: 'Zestawy',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    seq: 'cat-07',
    color: 'bg-orange-100/60',
  },
  {
    id: 'underwear',
    nameKey: 'category.underwear',
    polishName: 'Bielizna / Majtki',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    seq: 'cat-08',
    color: 'bg-pink-100/60',
  },
  {
    id: 'jersey',
    nameKey: 'category.jersey',
    polishName: 'Koszulki sportowe',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    seq: 'cat-09',
    color: 'bg-lime-100/60',
  },
  {
    id: 'accessories',
    nameKey: 'category.accessories',
    polishName: 'Akcesoria',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    seq: 'cat-10',
    color: 'bg-indigo-100/60',
  },
  {
    id: 'bags',
    nameKey: 'category.bags',
    polishName: 'Torby',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    seq: 'cat-11',
    color: 'bg-stone-100/60',
  },
  {
    id: 'belts',
    nameKey: 'category.belts',
    polishName: 'Paski',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    seq: 'cat-12',
    color: 'bg-cyan-100/60',
  },
  {
    id: 'perfumes',
    nameKey: 'category.perfumes',
    polishName: 'Perfumy',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    seq: 'cat-13',
    color: 'bg-fuchsia-100/60',
  },
  {
    id: 'other',
    nameKey: 'category.other',
    polishName: 'Inne rzeczy',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    seq: 'cat-14',
    color: 'bg-red-100/60',
  },
];

export const finds = [
  {
    id: 1,
    name: 'Nike Air Jordan 4 Retro',
    category: 'Buty',
    rating: '9.5/10',
    seq: 'find-01',
  },
  {
    id: 2,
    name: 'Balenciaga Hoodie Oversized',
    category: 'Bluzy / Swetry',
    rating: '9.2/10',
    seq: 'find-02',
  },
  {
    id: 3,
    name: 'Vintage Carhartt Jacket',
    category: 'Kurtki',
    rating: '8.9/10',
    seq: 'find-03',
  },
  {
    id: 4,
    name: 'Supreme Box Logo Tee',
    category: 'T-Shirty',
    rating: '9.0/10',
    seq: 'find-04',
  },
  {
    id: 5,
    name: 'New Era 59FIFTY Fitted Cap',
    category: 'Nakrycia głowy',
    rating: '8.7/10',
    seq: 'find-05',
  },
  {
    id: 6,
    name: 'Essentials Fear of God Set',
    category: 'Zestawy',
    rating: '9.3/10',
    seq: 'find-06',
  },
];

export const faqData = [
  {
    id: 1,
    category: 'Podstawy',
    question: 'Czym jest Kakobuy Spreadsheet?',
    answer: 'Kakobuy Spreadsheet to kompleksowa, regularnie aktualizowana baza danych zawierająca setki sprawdzonych linków do produktów dostępnych na platformie Kakobuy. Każdy produkt przechodzi weryfikację jakości i otrzymuje ocenę od naszej społeczności.',
  },
  {
    id: 2,
    category: 'Aktualizacje',
    question: 'Jak często aktualizowany jest spreadsheet?',
    answer: 'Spreadsheet jest aktualizowany co tydzień. Nasz zespół regularnie dodaje nowe znaleziska, usuwa niedostępne produkty i aktualizuje oceny jakości na podstawie opinii społeczności.',
  },
  {
    id: 3,
    category: 'Dostęp',
    question: 'Czy Kakobuy Spreadsheet jest darmowy?',
    answer: 'Tak, dostęp do pełnej bazy Kakobuy Spreadsheet jest całkowicie darmowy. Wszystkie linki, oceny i porównania są dostępne bez żadnych opłat dla wszystkich użytkowników.',
  },
  {
    id: 4,
    category: 'Bezpieczeństwo',
    question: 'Czy produkty w spreadsheetzie są bezpieczne?',
    answer: 'Każdy produkt w naszej bazie przechodzi weryfikację. Sprawdzamy autentyczność sprzedawców, jakość produktów na podstawie zdjęć QC oraz opinie innych kupujących. Dodatkowo udostępniamy poradnik bezpiecznych zakupów.',
  },
  {
    id: 5,
    category: 'Porównanie',
    question: 'Czym Kakobuy Spreadsheet różni się od CSSBuy Spreadsheet?',
    answer: 'Kakobuy Spreadsheet oferuje szerszy wybór kategorii, bardziej szczegółowe oceny jakości oraz częstsze aktualizacje. Nasza społeczność jest również bardziej aktywna w dodawaniu nowych znalezisk i dzieleniu się opiniami.',
  },
];